import { Spinner } from '@cimpress/react-components';
import axios from 'axios';
import { useCallback, useEffect, useState } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';

import App from './App';
import auth from './utilities/authentication';
import { isInCometPortal } from './utilities/helper';

type AuthState = {
  isUserAuthenticating: boolean;
  authenticationError: string | null;
};
if (!isInCometPortal()) {
  auth.on('tokenExpired', () => auth.login({ nextUri: window.location.href }));
}

const AppWithAuthWrapper = () => {
  const [authState, setAuthState] = useState<AuthState>({
    isUserAuthenticating: !isInCometPortal(),
    authenticationError: null,
  });

  // Authenticate user
  const authenticateUser = useCallback(async () => {
    if (isInCometPortal()) {
      setAuthState({ isUserAuthenticating: false, authenticationError: null });
      return;
    }
    return auth
      .ensureAuthentication({ nextUri: window.location.href })
      .then(() => {
        axios.defaults.headers.common.Authorization = `Bearer ${auth.getAccessToken()}`;

        if (auth.isLoggedIn()) {
          setAuthState((prevState) => {
            return {
              ...prevState,
              isUserAuthenticating: false,
            };
          });
        }
      })
      .catch((error: { message: string }) => {
        setAuthState((prevState) => {
          return {
            ...prevState,
            authenticationError: error.message,
            isUserAuthenticating: false,
          };
        });
      });
  }, []);
  useEffect(() => {
    authenticateUser();
  }, [authenticateUser]);

  if (authState.isUserAuthenticating) {
    return <Spinner size="large" fullPage />;
  }

  if (authState.authenticationError) {
    return (
      <div>
        <h1>There was an error authenticating your credentials:</h1>
        <div>
          <b>{authState.authenticationError}</b>
        </div>
        <h3>Please try again.</h3>
        <h4>
          If this issue continues, please
          <a href="mailto:mis-emt@cimpress.com">contact support</a>
          for assistance.
        </h4>
      </div>
    );
  }

  return (
    <Router>
      <App />
    </Router>
  );
};

export default AppWithAuthWrapper;
